import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    }, []);
    const register = useCallback(async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        setUser(data);
        return data;
    }, []);
    const logout = useCallback(async () => {
        await api.post("/auth/logout");
        setUser(false);
    }, []);

    const toggleFavorite = useCallback(async (editorId) => {
        const { data } = await api.post(`/favorites/${editorId}/toggle`);
        setUser((u) => (u ? { ...u, favorites: data.favorites } : u));
        return data.favorites;
    }, []);

    const value = useMemo(
        () => ({ user, setUser, loading, login, register, logout, checkAuth, toggleFavorite }),
        [user, loading, login, register, logout, checkAuth, toggleFavorite]
    );

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
